import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_SALT!;

// const deriveKey = (salt: string): string => {
//     return CryptoJS.PBKDF2(SECRET_KEY, salt, { keySize: 256 / 32 }).toString();
// };

export const encryptData = (data: any): string => {
    const jsonString = JSON.stringify(data);
    // const key = deriveKey(salt);
    // const encrypted = CryptoJS.AES.encrypt(jsonString, key).toString();
    const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
    return encrypted;
};

export const decryptData = (cipherText: string): any | null => {
    try {
        // const key = deriveKey(salt);
        // const bytes = CryptoJS.AES.decrypt(cipherText, key);
        const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return decrypted;
    } catch (error) {
        console.error("Erreur de déchiffrement :", error);
        return null;
    }
};

// export const setSecureItem = (key: string, value: any, salt: string) => {
//     const encryptedValue = encryptData(value, salt);
//     localStorage.setItem(key, encryptedValue);
// };

// export const getSecuredItem = (key: string, salt: string): any | null => {
//     const encryptedValue = localStorage.getItem(key);
//     return encryptedValue ? decryptData(encryptedValue, salt) : null;
// };

// export const removeSecureItem = (key: string) => {
//     localStorage.removeItem(key);
// };
